import React from "react";
// import data from "../data/data.json";
import { useContext, createContext, useState, useEffect, useRef } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import hash from "object-hash";
import { camelize } from "../util/format";
import { calculateDistance } from "../util/distance";

const MapContext = createContext({});

export default function MapContextProvider({
  children,
  googleMapsApiKey,
  baseUrl,
  dataUrl,
}) {
  const [hover, setHover] = useState(null);
  const timeout = useRef(null);
  const providers = useRef([]);
  const [map, setMap] = useState(null);
  const [filter, setFilter] = useState({});
  const [openCard, setOpenCard] = useState(null);
  const [providerMarkers, setProviderMarkers] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showList, setShowList] = useState(true);

  const mapConfig = {
    id: "google-map-script",
    googleMapsApiKey,
    libraries: ["places"],
  };

  const { isLoaded } = useJsApiLoader(mapConfig);

  useEffect(() => {
    isLoaded &&
      fetch(dataUrl)
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          let count = 0;
          const limit = 10000;
          console.log({ result });
          if (result.ERGEBNIS) {
            for (var key in result.ERGEBNIS) {
              count++;
              if (count <= limit)
                providers.current.push(result.ERGEBNIS[key].DATENSATZ);
            }
            updateProviderMarkers();
          }
        })
        .catch((err) => console.log({ err }));
  }, [isLoaded]);

  useEffect(() => {
    if (!providers?.current?.length > 0 || !isLoaded) return;
    updateProviderMarkers();
  }, [isLoaded]);

  // useEffect(() => {
  //   filterProviderMarkers();
  // }, [filter]);

  const addFilter = ({ type, value }) => {
    const newFilter = { ...filter };
    newFilter[type] = value;
    setFilter(newFilter);
  };

  // const filterProviderMarkers = () => {
  //   const newProviderMarkers = providerMarkers.map((provider) => ({
  //     ...provider,
  //     visible: checkVisibility(provider),
  //   }));
  //   setProviderMarkers(newProviderMarkers);
  // };

  const checkVisibility = (provider) => {
    const filtersMet = [];
    // console.log(filter);
    for (const [type, value] of Object.entries(filter)) {
      if (type === "text") {
        if (value.trim() !== "") {
          const searchText = (
            provider.address +
            provider.firma +
            provider.vornamePrivatperson +
            provider.nachnamePrivatperson
          ).toLowerCase();
          const found = searchText.indexOf(value.toLowerCase());
          // console.log({ searchText, found });
          if (found < 0) filtersMet.push(false);
        }
      } else {
        let selected = false;
        if (value.length <= 0) {
          selected = true;
        } else {
          value.map((label) => {
            if (provider[type].indexOf(label) >= 0) selected = true;
          });
          value.map(({ label }) => {
            if (provider[type].indexOf(label) >= 0) selected = true;
          });
        }
        if (!selected) filtersMet.push(false);
      }
    }
    let visible = true;
    filtersMet.map((value) => {
      if (value === false) visible = false;
    });
    // console.log({ visible });
    return visible;
  };

  const updateProviderMarkers = () => {
    const newProviderMarkers = [];
    providers.current.map(async (provider) => {
      const address = `${provider.STRASSE}, ${provider.PLZ} ${provider.ORT}, ${provider.LAND}`;
      if (provider.LAT) {
        const newProviderMarker = {
          name: `${
            provider.FIRMA ||
            ` ${provider["VORNAME-PRIVATPERSON"]}  ${provider["NACHNAME-PRIVATPERSON"]}`
          }`.trim(),
          address,
          geo: { lat: parseFloat(provider.LAT), lng: parseFloat(provider.LNG) },
          key: hash(provider),
          visible: true,
        };

        for (const [key, value] of Object.entries(provider)) {
          newProviderMarker[camelize(key)] = value;
        }

        newProviderMarkers.push(newProviderMarker);
      }
    });
    setProviderMarkers(newProviderMarkers);
  };

  const handleBoundsChanged = () => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      if (!map) return;
      const center = { lat: map.getCenter().lat(), lng: map.getCenter().lng() };
      const distProviderMarkers = providerMarkers.map((provider) => {
        const dist = calculateDistance(provider?.geo, center);
        // const visible = map.getBounds().contains(provider.geo);
        return { ...provider, dist };
      });
      const newProviderMarkers = distProviderMarkers.sort(function (a, b) {
        return a.dist - b.dist;
      });
      setProviderMarkers(newProviderMarkers);
    }, 100);
  };

  const setOpen = (openedKey) => {
    const provider =
      providerMarkers.filter(({ key }) => key === openedKey)?.[0] || null;
    setOpenCard(provider);
    setShowFilter(false);
    if (provider && !map.getBounds().contains(provider?.geo)) {
      map.setCenter(provider?.geo);
    }
  };

  const filteredProviderMarkers = providerMarkers.filter((provider) =>
    checkVisibility(provider)
  );

  console.log({ filteredProviderMarkers });

  return (
    <MapContext.Provider
      value={{
        providers,
        providerMarkers: filteredProviderMarkers,
        map,
        setMap,
        isLoaded,
        handleBoundsChanged,
        openCard,
        setOpen,
        addFilter,
        hover,
        setHover,
        baseUrl,
        setShowFilter,
        showFilter,
        showList,
        setShowList,
      }}
    >
      {children}
    </MapContext.Provider>
  );
}

export const useMapContext = () => useContext(MapContext);
